import script from "./LoadingSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./LoadingSkeleton.vue?vue&type=style&index=0&id=4cce2007&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cce2007"]])

export default __exports__